import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import FieldGroup from "./FieldGroup";
import InputDate from "./InputDate";
import { Button, Col, Container, FormControl, FormGroup, Modal, Row } from "react-bootstrap";
import Autosuggest from "../Autosuggest/Autosuggest"

import {
    hideTicketModal,
    persistTicket,
    showTicketModal,
    updateTicketData,
    updateTicketInList
} from "../../../../../actions/tickets";
import { showDialog } from "../../../../../actions/ui";

import { HoverRowColor, WerfenColor, White } from "../../../../Constants/ColorChart";
import { formatDate } from "../../../../../../web/Utils/utils";
import 'date-input-polyfill-react';
import { BackendURL } from "../../../../Constants/AppData";
import styled from "styled-components";
import Dialog from "../../../Dialog/Dialog";

const StyledModal = styled ( Modal )`
    & .modal-dialog.modal-lg{
        max-width: 1200px;
    }
`

const StyledModalHeader = styled ( Modal.Header )`
    & .close{
        border: 0 none transparent;
        background: ${ White };
        font-size: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 15px;
        top: 10px;
        width: 40px;
        height: 40px;
        opacity: 0.5;
        &:hover {
            opacity: 1;
        }
        & .sr-only {
            display: none;
        }
    }
`
const StyledModalBody = styled ( Modal.Body )`
    & .ticketFileUpload{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%
        &.loading{
            opacity: 0.5
        }
    }
    
    .attachments {
        ul {
            list-style: none;
            display: flex;
            margin-bottom: 36px;
            padding: 0;
            flex-direction: column;
            max-height: 135px;
            overflow-y: auto;
            overflow-x: hidden;
        }
        
        li {
            display: flex;
            align-items: flex-start;
            flex-grow: 1;
            &:hover{
                background: ${ HoverRowColor };
            }
        }
        
        a {
            display: flex;
            flex-grow: 1;
            text-decoration: none;
            padding: 10px;
            &:hover {
                text-decoration: underline;
            }
        }
    }
    
    & label {
        padding-top: 16px;
    }
    
    & .deleteAttachment {
        padding: 10px;
        margin: 0;
        display: inline-block;
        opacity: 0.5;
        background: transparent;
        border: 0px solid transparent;
        span {
            display: inline-block;
            background: #dc3545;
            color: white;
            border-radius: 30px;
            height: 20px;
            width: 19px;
            line-height: 20px;
            font-weight: bold;
            font-size: 18px;
        }
        &:hover{
            opacity: 1
        }
    }
`

const StyledSubmit = styled ( Button )`
    background: ${ WerfenColor }!important;
    color: ${ White };
    border-radius: 0!important;
    border: 0 none transparent!important;
    outline: 0 none transparent!important;
    boxShadow: unset!important;
    margin-top: 20px;
`

const TicketModal = ( props ) => {
    const [ form, setForm ] = useState ( {} );
    const [ fileList, setFileList ] = useState ( [] );

    const materialTypesList = props.materialTypesList || [];
    const ticketStatusesList = props.ticketStatusesList || [];
    const executorTeams = props.executorTeams || [];
    const executorTeamMembers = props.executorTeamMembers || [];
    const usersInTicketList = props.usersInTicketList || [];
    const attachmentsList = props.attachmentsList || [];
    const showResponseStatusValues = [ "DONE", "REJECTED", "FEEDBACK" ];
    const showResponseStatusIds = ticketStatusesList
        .filter ( item => showResponseStatusValues.includes ( item.name ) )
        .map ( item => item.id );
    const dateNow = new Date ();
    const TODAY = dateNow.toISOString ().substr ( 0, 10 );

    const ticketDataId = props.ticketData.id;
    const typeLabel = ticketDataId ? "Update " : "Create ";
    const type = typeLabel.trim ().toLowerCase ();
    const buttonDisabled = !!props.ticketData.subject &&
        !!props.ticketData.author &&
        !!props.ticketData.assigned

    useEffect ( () => {
        setForm ( props.ticketData );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.ticketData ] );

    const autosuggestChange = ( data ) => {
        const type = props.ticketData.id ? "update" : "create";
        if ( data.value !== null ) {
            const obj = {
                target: data
            }
            handleChange ( obj, type )
        }
    }

    const updateThen = ( name, value ) => {
        return new Promise ( ( resolve, reject ) => {
            try {
                props.updateTicketData ( {
                    name,
                    value
                } )
                resolve ( true )
            } catch ( error ) {
                console.error ( error )
                reject ( error )
            }
        } )
    }

    const handleChange = ( event, type ) => {
        const { name, value } = event.target;
        //console.info( { event, type })

        setForm ( prevState => ( {
                ...prevState,
                [name]: value
            } )
        );
        updateThen ( name, value )
            .then ( ( response ) => {
                if ( response === true && type === "update" &&
                    (
                        name === "status" ||
                        name === "materialType" ||
                        name === "assigned" ||
                        name === "executorTeam"
                    )
                ) {
                    handleSubmit ( null, type )
                }
            } )
            .catch ( error => console.error ( error ) )

    }

    const handleSubmit = ( event, type ) => {
        if ( event !== null ) {
            event.preventDefault ();
        }

        let myHeaders = new Headers ();
        const ticketData = form;
        const objectToSend = {
            data: {
                "type": "ticket--ticket",
                "attributes": {
                    summary: ticketData.subject,

                    field_ticket_job_position: ticketData.jobTitle ? ticketData.jobTitle : "DUMMY TEXT",
                    field_ticket_original_requester: ticketData.originalRequester ? ticketData.originalRequester : "DUMMY TEXT",

                    field_ticket_resource: ticketData.resource,         // <<<<

                    field_ticket_requested_date: ticketData.requestedDate,
                    field_ticket_date_needed_by: ticketData.necessityDate,
                    field_ticket_due_date: ticketData.dueDate,

                    field_ticket_description: ticketData.description,

                    field_ticket_company: "DUMMY TEXT",//ticketData.company,
                    field_ticket_email: [ { value: "dummyemail@example.org" } ],//ticketData.email,
                    field_ticket_phone: "DUMMY TEXT",//ticketData.phone,
                },
                relationships: {
                    field_ticket_assignee: ticketData.assigned ? {
                        data: {
                            type: "user--user",
                            id: ticketData.assigned
                        }
                    } : undefined,
                    field_ticket_status: ticketData.status ? {
                        data: {
                            type: "taxonomy_term--ticket_status",
                            id: ticketData.status
                        }
                    } : props.ticketStatusesList[0].id,
                    field_ticket_material_type: ticketData.materialType ? {
                        data: {
                            type: "taxonomy_term--material_type",
                            id: ticketData.materialType
                        }
                    } : props.materialTypesList[0].id,
                    field_ticket_requester: {
                        data: {
                            type: "user--user",
                            id: ticketData.author
                        }
                    },
                    field_ticket_executors_team: ticketData.executorTeam ? {
                        data: {
                            type: "executors_team--executors_team",
                            id: ticketData.executorTeam
                        }
                    } : {
                        data: {
                            type: "executors_team--executors_team",
                            id: window.localStorage.getItem ( "teamUUID" )
                        }
                    },
                    field_ticket_sales_org: {
                        data: {
                            type: "sales_org--sales_org",
                            id: ticketData.salesOrg
                        }
                    },
                    field_ticket_ticketing_system: {
                        "data": {
                            type: "ticketing_system--ticketing_system",
                            id: props.userTicketingSystem
                        }
                    },

                    field_ticket_attachments: {
                        data: ticketData.attachments,
                    }
                }
            }
        }

        if ( ticketData.resolution && ticketData.resolution !== "" /*&& props.ticketStatusesList.includes(props.ticketData.status) */ ) {
            objectToSend.data.attributes.field_ticket_resolution = ticketData.resolution;
        }

        if ( type === "update" ) {
            objectToSend.data.id = ticketData.uuid;
        }

        myHeaders.append ( "Content-Type", "application/vnd.api+json" );
        myHeaders.append ( "Accept", "application/vnd.api+json" );
        myHeaders.append ( "Authorization", "Bearer " + window.localStorage.getItem ( "token" ) );

        const body = JSON.stringify ( objectToSend );

        const requestOptions = {
            method: type === "create" ? 'POST' : 'PATCH',
            headers: myHeaders,
            body,
            redirect: 'follow'
        };
        let urlToSend = BackendURL + "/jsonapi/ticket/ticket";
        if ( type === "update" ) {
            urlToSend += "/" + ticketData.uuid
        }
        fetch ( urlToSend, requestOptions )
            .then ( response => response.text () )
            .then ( () => {
                props.updateTicketInList ( ticketData );
            } )
            .then ( () => {
                if ( event !== null ) {
                    props.setLoading ( true );
                    props.hideTicketModal ();
                    setFileList ( [] );
                }
            } )
            .catch ( error => console.error ( 'Error: ', error ) );
    }

    const fileOnChange = async ( event, value ) => {
        event.preventDefault ();

        let myHeaders = new Headers ();
        myHeaders.append ( "Accept", "application/vnd.api+json" );
        myHeaders.append ( "Authorization", "Bearer " + window.localStorage.getItem ( "token" ) );
        myHeaders.append ( "Content-Disposition", "file; filename=\"" + [ ...value ][0].name + "\"" );
        myHeaders.append ( "Content-Type", "application/octet-stream" );
        myHeaders.append ( "Host", BackendURL );

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: value[0],
        }

        let urlToSend = BackendURL + "/jsonapi/ticket/ticket/field_ticket_attachments";
        const response = await fetch ( urlToSend, requestOptions );
        const result = await response.json ();

        const fileToParse = {
            type: "file--file",
            id: result.data.id,
            meta: { display: true, description: "" },
            name: result.data.attributes.filename
        }

        const fileArray = form.attachments || [];
        const newFileList = [ ...fileArray, fileToParse ];

        setForm ( prevState => ( {
                ...prevState,
                attachments: newFileList
            } )
        );

        setFileList ( prevState => ( [
            ...prevState,
            fileToParse
        ] ) );

        return newFileList

        // Documentation is lacking on Drupal's JSON:API for uploads, use 
        // https://www.drupal.org/node/3024331
        // in short: use the endpoint, get a UUID and create a relationship with the data being stored.
    }

    const removeFromAttachmentFromTicket = ( idToRemove ) => {
        const fileArray = form.attachments;

        props.showDialog ( {
            dialogTitle: "Removing File",
            dialogBody: [ "This will remove the selected file from this ticket. This action cannot be undone!" ],
            callback: () => {
                // console.info(isAlreadyAttached);
                const newFileArray = fileArray.filter ( ( item ) => item.id !== idToRemove );
                const newFileList = fileList.filter ( ( item ) => item.id !== idToRemove );

                setForm ( prevState => ( {
                        ...prevState,
                        attachments: newFileArray
                    } )
                )
                setFileList ( newFileList );

                props.updateTicketData ( {
                    name: "attachments",
                    value: newFileArray
                } )
            }
        } )
    }

    const getFileDownloadToken = ( id ) => {
        return new Promise ( ( resolve, reject ) => {
            const controller = new AbortController ();
            const timeoutId = setTimeout ( () => controller.abort (), 10000 );
            const token = localStorage.getItem ( "token" );

            fetch ( BackendURL + "/file/" + id + "/get-download-token", {
                signal: controller.signal,
                headers: {
                    'content-type': 'text/plain',
                    'Authorization': 'Bearer ' + token
                },
                authorization: 'Bearer ' + token,
                method: 'POST',
                body: ""
            } )
                .then ( result => {
                    if ( !result.ok ) {
                        return reject ( result )
                    }
                    return result.json ()
                } )
                .then ( response => {
                    if ( response.status === 403 || response.status === 401 ) {
                        localStorage.clear ();
                        window.location.href = "/";
                    }
                    // console.info(response);
                    resolve ( response );
                    clearTimeout ( timeoutId );
                } )
                .catch ( error => {
                    if ( error.name === "AbortError" ) {
                        console.error ( "Timeout" );
                        reject ( "AbortError" );
                    } else {
                        console.error ( "Error fetching the file token." )
                    }
                } )
        } )

    }

    const handleDownload = ( id, filename ) => {
        getFileDownloadToken ( id )
            .then ( response => {
                // console.info( response );
                let link = document.createElement ( 'a' );
                link.download = filename;
                link.href = BackendURL + "/file/" + response.media_uuid + '/download/' + response.token;
                link.click ();
                //console.info( "Link:", link );
                link.remove ();
            } )
            .catch ( error => console.error ( error ) );
    }

    return (
        <>
            <StyledModal show={ props.visibleTicketModal }
                         onHide={ () => {
                             setFileList ( [] )
                             props.hideTicketModal ()
                         } }
                         size="lg"
                         backdrop="static"
            >
                <StyledModalHeader closeButton className={ "with-close-button" }>
                    <Modal.Title>TICKET { ticketDataId ? ticketDataId : "FORM" }</Modal.Title>
                </StyledModalHeader>
                <StyledModalBody>
                    <Container fluid>
                        <form
                            id="ticketModal"
                            onSubmit={ ( event ) => {
                                const type = ticketDataId ? "update" : "create"
                                handleSubmit ( event, type )
                            }
                            }>
                            <Row>
                                <Col md={ 8 }>
                                    <FieldGroup
                                        id="id"
                                        type="text"
                                        label="Subject"
                                        name={ "subject" }
                                        isRequired={ true }
                                        value={ props.ticketData.subject || "" }
                                        disabled={ props.ticketData.orders === true }
                                        onChange={ ( event ) => handleChange ( event, type ) }
                                        placeholder="Subject"
                                    />
                                </Col>
                                <Col md={ 4 }>
                                    <FormGroup controlId="status">
                                        <label>Status</label>
                                        <FormControl
                                            name={ "status" }
                                            as="select"
                                            defaultValue={ props.ticketData.status }
                                            disabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                            placeholder="Status"
                                            onChange={ ( event ) => handleChange ( event, type ) }>
                                            { ticketStatusesList.map ( ( item, index ) => {
                                                return <option key={ index }
                                                               selected={ item.id === props.ticketData.status }
                                                               value={ item.id }>{ item.name }</option>
                                            } ) }
                                        </FormControl>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={ 4 }>
                                    <FormGroup id="requestedDate">
                                        <label htmlFor="requestedDate">Creation date:</label>
                                        <InputDate
                                            id="requestedDate"
                                            name="requestedDate"
                                            isFormField={ true }
                                            value={ props.ticketData.requestedDate || TODAY }
                                            properDate={ formatDate ( props.ticketData.requestedDate ) || formatDate ( TODAY ) }
                                            disabled={ props.ticketData.orders === true }
                                            handleChange={ ( event ) => handleChange ( event, type ) }
                                            required={ false }
                                            isDisabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={ 4 }>
                                    <FormGroup id="necessityDate">
                                            <label htmlFor="necessityDate">
                                                Necessity date:
                                                { props.session.teamUUID !== undefined &&
                                                    <span style={ { color: "red" } }> *</span> }
                                            </label>
                                        <InputDate
                                            id="necessityDate"
                                            name="necessityDate"
                                            isFormField={ true }
                                            value={ props.ticketData.necessityDate || "" }
                                            properDate={ formatDate ( props.ticketData.necessityDate ) }
                                            handleChange={ ( event ) => handleChange ( event, type ) }
                                            required={ props.session.teamUUID !== undefined }
                                            isDisabled={ false }
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={ 4 }>
                                    <FormGroup id="dueDate">
                                        <label htmlFor="dueDate">Delivery date:</label>
                                        <InputDate
                                            id="dueDate"
                                            name="dueDate"
                                            isFormField={ true }
                                            value={ props.ticketData.dueDate || "" }
                                            properDate={ formatDate ( props.ticketData.dueDate ) }
                                            disabled={ props.ticketData.orders === true }
                                            handleChange={ ( event ) => handleChange ( event, type ) }
                                            required={ false }
                                            isDisabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={ 4 }>
                                    <Autosuggest
                                        fieldId={ "author" }
                                        label={ "Author" }
                                        name={ "author" }
                                        delay={ 500 }
                                        isRequired={ true }
                                        placeholder="Select a user ..."
                                        value={ props.ticketData.author || "" }
                                        disabled={ props.ticketData.orders === true }
                                        handleChange={ autosuggestChange }
                                        uuid={ props.ticketData.author }
                                        uname={ props.ticketData.author && usersInTicketList.find ( item => item.id === props.ticketData.author ) ? usersInTicketList.find ( item => item.id === props.ticketData.author ).name : "" }
                                        salesOrgsList={ props.salesOrgsList }
                                        isDisabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                    />
                                </Col>
                                <Col md={ 4 }>
                                    <FieldGroup
                                        fieldId={ "originalRequester" }
                                        label={ "Original Requester" }
                                        name={ "originalRequester" }
                                        isRequired={ true }
                                        placeholder="Type the original requester name ..."
                                        value={ props.ticketData.originalRequester || "" }
                                        disabled={ props.ticketData.orders === true }
                                        onChange={ ( event ) => handleChange ( event, type ) }
                                    />
                                </Col>
                                <Col md={ 4 }>
                                    <FieldGroup
                                        id="salesOrg_name"
                                        type="text"
                                        value={ props.ticketData.salesOrg ? props.salesOrgsList.find ( item => item.id === props.ticketData.salesOrg ).name.replace ( "Werfen ", "" ) : "" }
                                        label="Sales Organization"
                                        placeholder="Sales Organization"
                                        name="salesOrg_name"
                                        disabled={ true }
                                    />
                                    <input
                                        type="hidden"
                                        id="salesOrg"
                                        name="salesOrg"
                                        value={ props.ticketData.salesOrg ? props.ticketData.salesOrg : "" }
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={ 8 }>
                                    <FieldGroup
                                        id="resource"
                                        type="text"
                                        label="Download Delivery"
                                        placeholder="Download Delivery"
                                        name={ "resource" }
                                        value={ props.ticketData.resource || "" }
                                        disabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                        onChange={ ( event ) => handleChange ( event, type ) }
                                    />
                                </Col>
                                <Col md={ 4 }>
                                    <FormGroup controlId="materialType">
                                        <label>Material type</label>
                                        <FormControl name={ "materialType" }
                                                     as="select"
                                                     placeholder="Material type"
                                                     defaultValue={ props.ticketData.materialType }
                                                     disabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                                     onChange={ ( event ) => handleChange ( event, type ) }>
                                            { materialTypesList.map ( ( item, index ) => {
                                                return <option key={ index }
                                                               value={ item.id }>{ item.name }</option>
                                            } ) }
                                        </FormControl>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={ 8 }>
                                    <FormGroup controlId="description">
                                            <label>
                                                Description
                                                { props.session.teamUUID !== undefined &&
                                                    <span style={ { color: "red" } }> *</span> }
                                            </label>
                                        <FormControl as="textarea"
                                                     placeholder="Description"
                                                     name={ "description" }
                                                     rows={ 14 }
                                                     required={ props.session.teamUUID !== undefined }
                                                     value={ props.ticketData.description || "" }
                                                     onChange={ ( event ) => handleChange ( event, type ) }
                                        />
                                    </FormGroup>
                                    { showResponseStatusIds.includes ( props.ticketData.status ) &&
                                    <FormGroup controlId="resolution">
                                        <label>Resolution</label>
                                        <FormControl as="textarea"
                                                     placeholder="Response"
                                                     name={ "resolution" }
                                                     rows={ 14 }
                                                     required={ true }
                                                     value={ props.ticketData.resolution || "" }
                                                     onChange={ ( event ) => handleChange ( event, type ) }
                                                     disabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                        />
                                    </FormGroup> }
                                </Col>
                                <Col md={ 4 }>
                                    <FormGroup controlId="assigned">
                                        <label>
                                            Assigned To
                                            <span style={ { color: "red" } }> *</span>
                                        </label>
                                        <FormControl name={ "assigned" }
                                                     as="select"
                                                     defaultValue={ props.ticketData.assigned }
                                                     placeholder=""
                                                     disabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                                     onChange={ ( event ) => handleChange ( event, type ) }
                                        >
                                            <option>Unassigned</option>
                                            { executorTeamMembers.map ( ( item, index ) => {
                                                return <option key={ index }
                                                               value={ item.id }>{ item.name }</option>
                                            } ) }
                                        </FormControl>
                                    </FormGroup>
                                    <FormGroup controlId="executorTeam">
                                        <label>
                                            Team
                                        </label>
                                        {
                                            executorTeams.length > 1 &&
                                            <FormControl name={ "executorTeam" }
                                                         as="select"
                                                         defaultValue={ props.ticketData.executorTeam }
                                                         placeholder=""
                                                         disabled={ props.session.teamUUID === undefined || props.session.canExecute === false }
                                                         onChange={ ( event ) => handleChange ( event, type ) }
                                            >
                                                <option>Please select a team...</option>
                                                { executorTeams.map ( ( item, index ) => {
                                                    return <option key={ index }
                                                                   value={ item.id }>{ item.name }</option>
                                                } ) }
                                            </FormControl>
                                        }
                                        {
                                            executorTeams.length === 1 &&
                                                <>
                                                    <div>Global communications</div>
                                                    <input type="hidden" name={ "executorTeam" }
                                                           value={ executorTeams[0].id }/>
                                                </>
                                        }
                                    </FormGroup>
                                    <FormGroup className={ "attachments" }>
                                        <label>Attachments</label>
                                        <ul>
                                            {
                                                props.ticketData.attachments &&
                                                props.ticketData.attachments.map ( ( item, index ) => {
                                                    // console.info(item)
                                                    const attachment = attachmentsList.find ( ( attachment ) => ( attachment.id === item.id ) )
                                                    return (
                                                        <li key={ attachment.id + "-" + index }>
                                                            <a
                                                                href={ "/#" }
                                                                onClick={ event => {
                                                                    event.preventDefault ();
                                                                    const { id, filename } = attachment;
                                                                    handleDownload ( id, filename );
                                                                } }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >{ attachment.filename }</a>
                                                            <button
                                                                className={ "deleteAttachment" }
                                                                onClick={ ( event ) => {
                                                                    event.preventDefault ()
                                                                    removeFromAttachmentFromTicket ( attachment.id, true );
                                                                } }
                                                            >
                                                                <span>×</span>
                                                            </button>
                                                        </li>
                                                    )
                                                } ) }
                                            {/*
                                                    // TODO: Remove this from local state and handle it by Redux.
                                                */ }
                                            {
                                                fileList.length > 0 &&
                                                fileList.map ( ( file, index ) => {
                                                    // console.info( file );
                                                    return (
                                                        <li key={ file.id + "-" + index }>
                                                            <a
                                                                href={ "/#" }
                                                                onClick={ event => {
                                                                    event.preventDefault ();
                                                                    const { id, filename } = file;
                                                                    handleDownload ( id, filename );
                                                                } }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                { file.name }
                                                            </a>
                                                            <button
                                                                className={ "deleteAttachment" }
                                                                onClick={ ( event ) => {
                                                                    event.preventDefault ()
                                                                    removeFromAttachmentFromTicket ( file.id, false );
                                                                } }
                                                            >
                                                                <span>×</span>
                                                            </button>
                                                        </li>
                                                    )
                                                } ) }
                                        </ul>
                                        <input
                                            id="ticketFileUpload"
                                            className="ticketFileUpload"
                                            type="file"
                                            name="file"
                                            multiple={ false }
                                            onChange={ ( event ) => {
                                                const { target } = event;
                                                target.classList.add ( "loading" );
                                                fileOnChange ( event, target.files )
                                                    .then ( () => {
                                                        target.classList.remove ( "loading" );
                                                        target.value = null;
                                                    } );
                                                // TODO: Add a reset for the input when done
                                                // TODO: Add error handling as well, this is a promise.
                                            } }
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={ { span: 4, offset: 8 } } className={ "text-end" }>
                                    <StyledSubmit
                                        disabled={ !buttonDisabled }
                                        type="submit"
                                    >
                                        { typeLabel } ticket
                                    </StyledSubmit>
                                </Col>
                            </Row>
                        </form>
                    </Container>

                </StyledModalBody>
                { props.dialogVisible &&
                <Dialog/>
                }
            </StyledModal>
        </>
    )

}

function mapStateToProps ( state ) {
    return {
        ticketData: state.tickets.ticketData,
        visibleTicketModal: state.tickets.visibleTicketModal,
        dialogVisible: state.ui.dialogVisible,
        session: state.session,
    };
}

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators ( {
        showTicketModal: showTicketModal,
        hideTicketModal: hideTicketModal,
        updateTicketData: updateTicketData,
        updateTicketInList: updateTicketInList,
        persistTicket: persistTicket,
        showDialog: showDialog,
    }, dispatch );
};


export default connect (
    mapStateToProps, mapDispatchToProps
) ( TicketModal );
